import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const SpaceImage = ({ url }) => {
  const [isLoading, setLoading] = useState(true);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const fetchUrl = async () => {
      const data = await fetch(`/api/og?url=${url}`)
        .then((result) => result.json())
        .catch((err) => {
          console.error(err);
          return false;
        });

      if (data && data.success) {
        setPreview(data);
      }
      setLoading(false);
    };
    fetchUrl();
  }, [url]);

  if (isLoading) {
    return <div className="loading-block has-background-light" />;
  }

  if (preview && preview.ogTitle) {
    // i was not sure why this was added so commenting this only.
    // host is never used after assigning value
    // let host = '';

    // if (url) {
    //   try {
    //     // host = new URL(url).hostname;
    //   } catch (err) {
    //     console.error(err);
    //   }
    // }
    let image = false;
    if (preview.ogImage) {
      if (Array.isArray(preview.ogImage)) {
        image = preview.ogImage[0].url;
      } else {
        image = preview.ogImage.url;
      }
      if (image && image.substring(0, 1) === '//') {
        image = `http:${image}`;
      }
    }

    if (image) {
      return (
        <figure className="image is-16by9">
          {image ? (
            <div
              className="widget-image"
              style={{
                backgroundImage: `url(${image})`,
              }}
            />
          ) : (
            ''
          )}
        </figure>
      );
    }
  }
  return null;
};

SpaceImage.propTypes = {
  url: PropTypes.string.isRequired,
};

export default SpaceImage;
